// value format: '<Folder Name under Procom.Phoenix.CQL/Resources/Client>.<fileName>.<Resource string defined in *.resx>'
export const WorkorderModuleResourceKeys = {
  generic: {
    newPlacementId: 'workorder.generic.newPlacementId',
  },
  messages: {
    workOrderExtensionNewPlacementId: 'workorder.messages.workOrderExtensionNewPlacementId'
  }
};
